<template>
  <span class="inline-flex items-center gap-1">
    <span>{{ value }}</span>
    <span
      v-if="delta !== 0 && delta !== null && delta !== undefined"
      :class="deltaClasses"
      class="text-xs font-medium px-1 py-0.5 rounded"
    >
      {{ deltaDisplay }}
    </span>
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: {
    type: Number,
    default: 0
  },
  delta: {
    type: Number,
    default: null
  }
})

const deltaDisplay = computed(() => {
  if (props.delta === null || props.delta === undefined || props.delta === 0) return ''
  return props.delta > 0 ? `+${props.delta}` : `${props.delta}`
})

const deltaClasses = computed(() => {
  if (props.delta > 0) {
    return 'text-green-700 bg-green-100'
  } else if (props.delta < 0) {
    return 'text-red-700 bg-red-100'
  }
  return ''
})
</script>
